var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVerifyEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 115,
    viewBox: "0 0 120 115",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.000732422 43.9734L54.1824 1.99023C57.6074 -0.66341 62.3934 -0.66341 65.8184 1.99023L120 43.9734V114.332H0.000732422V43.9734Z",
    fill: "#EE8F23"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M106.118 6.68066H13.8816V108.116H106.118V6.68066Z",
    fill: "#FAFAFA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M100.566 12.7871H19.4341V15.8795H100.566V12.7871Z",
    fill: "#DBDBDB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M88.3833 19.002H19.4341V22.0944H88.3833V19.002Z",
    fill: "#DBDBDB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M77.1958 25.2178H19.4341V28.3102H77.1958V25.2178Z",
    fill: "#DBDBDB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M77.1958 37.1514H19.4341V40.2438H77.1958V37.1514Z",
    fill: "#DBDBDB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2787 43.1182H19.4341V46.2106H62.2787V43.1182Z",
    fill: "#DBDBDB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M102.844 55.6191H59.9995V58.7116H102.844V55.6191Z",
    fill: "#DBDBDB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M102.844 61.709H67.9968V64.8014H102.844V61.709Z",
    fill: "#DBDBDB"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9997 79.1739L0.000732422 44.0156V114.332L59.9997 79.1739Z",
    fill: "#FFAC42"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9998 79.1739L119.999 44.0156V114.332L59.9998 79.1739Z",
    fill: "#FFAC42"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1816 72.3486L0 114.332H119.999L65.817 72.3486C62.3927 69.695 57.6066 69.695 54.1816 72.3486Z",
    fill: "#FFBE6E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifyEmail);
export default __webpack_public_path__ + "static/media/verifyEmail.3afdb3d7.svg";
export { ForwardRef as ReactComponent };